import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';
import { ButtonComponent, IconComponent } from '@recruitee/user-interface';

import { ReloadNotificationComponent } from './reload-notification.component';

@NgModule({
  imports: [ButtonComponent, IconComponent, I18nModule, ReloadNotificationComponent],
  exports: [ReloadNotificationComponent],
})
export class ReloadNotificationModule {}

export { ReloadNotificationComponent };
